import { anonymousHttpClient } from "../../../lib/http/axios";
import type { PublicItinerary } from "../types";
import { getPublicItinerary } from "./itineraryRepo";
import { getPublicItineraryTable } from "./itineraryTableRepo";
import type { components } from "../../../api/generated";

type ShareOpenResponse = { code: "OK"; data: components["schemas"]["ShareOpenResult"] };
type ShareViewResponse = { code: "OK"; data: components["schemas"]["ShareViewRecorded"] };

/** 请求一次分享打开决策，未授权时返回微信官方授权地址。 */
export async function openItineraryShare(shareId: string, openEventId: string) {
  const response = await anonymousHttpClient.post<ShareOpenResponse>(
    `/itineraries/public/${encodeURIComponent(shareId)}/open`,
    { open_event_id: openEventId },
    { withCredentials: true, "axios-retry": { retries: 0 } },
  );
  return response.data.data;
}

/** 并行读取公开行程及确认件客户输出，均成功后才允许计数。 */
export async function loadItineraryShareContent(shareId: string): Promise<PublicItinerary> {
  return getPublicItinerary(shareId);
}

/** 表格分享只读取表格事实，不依赖详情专用的酒店和团号输出。 */
export async function loadItineraryTableShareContent(shareId: string) {
  return getPublicItineraryTable(shareId);
}

/** 记录本次页面打开事件，服务端按事件幂等计数。 */
export async function recordItineraryShareView(shareId: string, openEventId: string) {
  const response = await anonymousHttpClient.put<ShareViewResponse>(
    `/itineraries/public/${encodeURIComponent(shareId)}/views/${encodeURIComponent(openEventId)}`,
    undefined,
    { withCredentials: true, "axios-retry": { retries: 2 } },
  );
  return response.data.data;
}
